/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-header[_ngcontent-%COMP%] {\r\n    border-bottom: none;\r\n}\r\n\r\n.modal-body[_ngcontent-%COMP%] {\r\n    margin-bottom: 60px;\r\n}\r\n\r\n.modal-footer[_ngcontent-%COMP%] {\r\n    width: 90%;\r\n    margin-top: auto;\r\n    position: absolute;\r\n    bottom: 0;\r\n    padding: 0.75rem 0;\r\n    right: 25px;\r\n    margin: 0 auto;\r\n    border-top: 2px solid #ddd;\r\n}\r\n\r\n.btn-respond[_ngcontent-%COMP%] {\r\n    min-width: 50px;\r\n}\r\n\r\n.body-message[_ngcontent-%COMP%] {\r\n    text-align: center;\r\n}"];
export { styles as styles };
